import React from "react";
import InputComponent from "../../../../componennts/input";
import {Info, InfoCircle} from "react-bootstrap-icons";
import Info_Component from "../components/info";
import FamilyStatus from "../core/data/family_status";

function PIB_Section(props) {

    let symbol = props.rs ?? '*/';

    const photo = props.valuePhoto;

    let cssClass = 'form-control rounded-0 border-0 border-bottom';

    const fields = [
        {
            required: false,
            title: "Дата народження",
            description: "",
            field: <InputComponent
                type={'date'}
                name={'valueDateBorn'}
                value={props.valueDateBorn}
                onChange={props.onChangeDateBorn}
                placeholder={'Дата народження'}
                class={cssClass}
            />
        },
        {
            required: true,
            title: "Місце народження",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueLocationBorn'}
                value={props.valueLocationBorn}
                onChange={props.onChangeLocationBorn}
                placeholder={'місто/селище, країна'}
                class={cssClass}
                style={props.style}
            />
        },
        {
            required: false,
            title: "ІПН", //(індивідуальний податковий номер)
            description: "(або іноземний ідентифікатор з поясненням)",
            field: <InputComponent
                type={'text'}
                name={'valueIPN'}
                value={props.valueIPN}
                onChange={props.onChangeIPN}
                placeholder={'індивідуальний податковий номер'}
                class={cssClass}
            />
        },
        {
            required: true,
            title: "Сімейний стан",
            description: "",
            field: <>
                <select name="familyStatus"
                        id="familyStatus"
                        className={cssClass}
                        value={props.valueFamilyStatus}
                        onChange={props.onChangeFamilyStatus}
                        style={props.style}
                >
                    <option selected disabled>- Оберіть сімейний стан -</option>
                    {
                        FamilyStatus.map((status, i) =>
                            // selected={props.valueFamilyStatus === status}
                            <option value={status} >{status}</option>
                        )
                    }
                </select>
            </>
        },
        {
            required: false,
            title: "Громадянство",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueCitizenship'}
                value={props.valueCitizenship}
                onChange={props.onChangeCitizenship}
                placeholder={'України'}
                class={cssClass}
            />
        },
        {
            required: false,
            title: "Національність",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueNationality'}
                value={props.valueNationality}
                onChange={props.onChangeNationality}
                placeholder={'Українець'}
                class={cssClass}
            />
        },
        {
            required: false,
            title: "Паспорт",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valuePassport'}
                value={props.valuePassport}
                onChange={props.onChangePassport}
                placeholder={'АБ 123456'}
                class={cssClass}
            />
        },
        {
            required: false,
            title: "Посвідчення водія",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueDriverLicense'}
                value={props.valueDriverLicense}
                onChange={props.onChangeDriverLicense}
                placeholder={'АБВ 123456'}
                class={cssClass}
            />
        },
        {
            required: false,
            title: "Паспорт для виїзду за кордон",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueForeignPassport'}
                value={props.valueForeignPassport}
                onChange={props.onChangeForeignPassport}
                placeholder={'АБ 123456'}
                class={cssClass}
            />
        },
        {
            required: false,
            title: "Посада/звання (місце роботи)",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueJobPosition'}
                value={props.valueJobPosition}
                onChange={props.onChangeJobPosition}
                placeholder={'Полковник ГРУ, МО РФ'}
                class={cssClass}
            />
        },
        {
            required: false,
            title: "Освіта",
            description: "",
            field: <InputComponent
                type={'text'}
                name={'valueEducation'}
                value={props.valueEducation}
                onChange={props.onChangeEducation}
                placeholder={'Ступінь, Спеціальність, Заклад освіти'}
                class={cssClass}
            />
        }
    ];

    return <div id={'pib_section'} className={'d-flex flex-wrap mb-2 mt-2'}>

        <div className={'col-md-4 col-12'}>

            <div className="wrap-image">
                <img src={photo ?? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2SHn6LfpKkhJJ-rZJILezziFL8GnP-40cZvvf-dExq290opM_WjN3mue_&s=10'} alt="avatar"
                     className={'btn-img img-fluid rounded-3 border border-3 bg-white p-2'}/>
                <input type='file' id='file' onChange={props.onChangePhoto}/>

                <Info_Component
                    text={'Для завантаження фотографії натисніть на зображення'}
                />
            </div>

        </div>

        <div className={'col-md-8 col-12 text-start'}>

            {
                fields.map((field, i) => <div className={'d-flex align-items-center justify-content-between -justify-content-start p-1'}>
                    <div className={'col-md-5 col-12'}>
                        <b>
                            {field.title}: {field.required && symbol}
                        </b>
                        <small className="text-muted">
                            {field.description}
                        </small>
                    </div>
                    <div className={'col-md-7 col-12'}>
                        {field.field}
                    </div>
                </div>)
            }

        </div>

    </div>
}

export default PIB_Section;
